export const LanguageEndpoints = {
  LanguagesList: '/v3/course/language'
} as const
